<template>
  <div class="d-flex flex-column align-center"
    style="height: 200px; background-color: #3EB83D"
  >
    <v-img 
      contain max-height="27px"
      src="@/assets/Referra_transparent_white_270x63.png"
      style="margin-top: 10px"
    />

    <v-icon class="mt-3" size="100px" color="white">mdi-check-circle-outline</v-icon>
    
    <div class="mt-2 white--text" style="font-weight: bold; font-size: 24px">
      Good luck with your project!
    </div>
  </div>
</template>

<script>


export default {
  name: 'QRConfirmationHeader',
}
</script>